import { Inject } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { SelectComponent, TextareaFieldComponent } from '@platform500services/p500-ui-kit';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormMessageComponent } from '../../components/form-fields/form-message/form-message.component';
import { ActionConfigAbstract } from '../../services/actions/abstracts/action-config.abstract';
import { FieldModel } from '../../services/actions/models/field.model';
import { IDataService } from '../../services/data/data-service.interface';
import { RbacServiceInterface } from '../../services/rbac/rbac-service.interface';

export class LastStepConfirmActionConfig extends ActionConfigAbstract {
  protected readonly key: string = 'AffiliateCrm\\AffiliateSteps\\EditAffiliateStep';
  protected readonly repository: string = 'Eloquent\\AffiliateStepsRepository';
  protected readonly title: string = '';
  protected readonly description: string = '';
  protected readonly fields: FieldModel[] = [];
  private stateCtr = new StateCtr(null, Validators.required);
  private reasonCtr = new UntypedFormControl(null, [Validators.required, Validators.maxLength(64)]);
  private subs$: Subscription;
  protected readonly dependHideFields = {
    declined_reason: this.stateCtr.valueChanges.pipe(map((v) => +v === 2 || v === null)),
  };

  constructor(
    @Inject('IDataService') dataService: IDataService,
    @Inject('RbacServiceInterface') rbacService: RbacServiceInterface,
    @Inject(String) url: string
  ) {
    super(dataService, rbacService);
    this.fields = [
      new FieldModel('', 'data', FormMessageComponent, new UntypedFormControl(), {
        data: $localize`:@@common.confirm_manager_doc:Confirm your manager's document?`,
        url,
      }),
      new FieldModel($localize`:@@common.confirm:Confirm`, 'state', SelectComponent, this.stateCtr, {
        data: new Map([
          [2, $localize`:@@common.done:Done`],
          [3, $localize`:@@common.blocked:Blocked`],
        ]),
      }),
      new FieldModel($localize`:@@common.reason:Reason`, 'declined_reason', TextareaFieldComponent, this.reasonCtr),
    ];
  }

  formHandlerOnInit(): void {
    this.subs$?.unsubscribe();
    this.subs$ = this.stateCtr.valueChanges.subscribe((value) => {
      if (+value === 3) this.reasonCtr.enable();
      else if (this.reasonCtr.enabled) this.reasonCtr.disable();
    });
  }

  formHandlerOnSubmit(): void {
    this.subs$?.unsubscribe();
  }
}
class StateCtr extends UntypedFormControl {
  public setValue(
    value: any,
    options?: {
      onlySelf?: boolean;
      emitEvent?: boolean;
      emitModelToViewChange?: boolean;
      emitViewToModelChange?: boolean;
    }
  ): void {
    if (+value === 0) value = null;
    super.setValue(value, options);
  }
}
